import { css } from 'styled-components';

export interface WithShadowProps {
  boxShadow?: string;
  dropShadow?: string;
}

export const withShadowCSS = ({
  boxShadow,
  dropShadow,
}: WithShadowProps) => css`
  ${boxShadow && `box-shadow: ${boxShadow};`}
  ${dropShadow && `filter: drop-shadow(${dropShadow})`}
`;
